export default __webpack_public_path__ + "static/media/HQV.9dc7b14a.jpg";